import styled from 'styled-components';

import { fontFamily } from 'stylesheet';

export const RootContainer = styled.div`
  height: 100%;
  overflow: auto;
`;
RootContainer.displayName = 'RootContainer';

export const PageContent = styled.main`
  font-family: ${fontFamily.main};
  height: 100%;
`;
PageContent.displayName = 'PageContent';
